import { GDM } from './datamanager';
import { dataUrl } from '../util/path';

export function playSoundByIdx(soundIdx: unknown): void {
  const index = Number(soundIdx);
  if (!Number.isInteger(index) || index <= 0) return;

  GDM.get('file_sound', (soundTable: any) => {
    if (index >= soundTable.rowCount) return;
    const soundPath = soundTable.item(index, 0);
    if (!soundPath) return;

    const audio = new window.Audio(dataUrl(soundPath));
    audio.volume = 0.5;
    void audio.play().catch(() => {
      // A browser can still reject playback due to its autoplay policy.
    });
  });
}

export function playHitSound(hitSoundIdx: unknown): void {
  const index = Number(hitSoundIdx);
  if (!Number.isInteger(index) || index <= 0) return;

  GDM.get('list_hitsound', (hitSoundTable: any) => {
    if (index >= hitSoundTable.rowCount) return;
    const variants = hitSoundTable.row(index)
      .map((soundIdx: unknown) => Number(soundIdx))
      .filter((soundIdx: number) => Number.isInteger(soundIdx) && soundIdx > 0);
    if (variants.length === 0) return;

    const variant = variants[Math.floor(Math.random() * variants.length)];
    playSoundByIdx(variant);
  });
}

export function playSkillSounds(skillData: any, ...columns: number[]): void {
  const played = new Set<number>();
  for (const column of columns) {
    const soundIdx = Number(skillData?.[column]);
    if (!soundIdx || played.has(soundIdx)) continue;
    played.add(soundIdx);
    playSoundByIdx(soundIdx);
  }
}
